<template>
  <div class="mobile-content">
    <div class="mobile-form">
      <div class="form-item">
        <div class="form-control">
          <nut-cell :show-icon="true" title="选择套餐" @click.native="showCloseIcon = true">
            <span slot="desc" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block; max-width: 240px;">{{labelProductName(currentProduct)}}</span>
          </nut-cell>
          <nut-popup
            position="bottom"
            closeable
            close-icon="cross"
            v-model="showCloseIcon"
            :style="{ height: '50%' }"
            close-icon-position="top-right"
          >
            <div class="popup-header">
              <h3>选择套餐</h3>
              <div class="search-container">
                <nut-textinput
                  v-model="packageSearchQuery"
                  placeholder="搜索套餐名称"
                  :clearBtn="true"
                  :disabled="false"
                  class="search-input"
                />
              </div>
            </div>
            <div class="popup-content">
              <div
                class="popup-item"
                v-for="item in filteredPackages"
                :key="item.id"
                @click="selectPackage(item)"
              >
                <div class="item-content">
                  <div class="item-name">{{ labelProductName(item) }}</div>
                  <div class="item-price">{{ item.price }}元/月</div>
                </div>
              </div>
              <div v-if="filteredPackages.length === 0" class="no-data">
                暂无匹配的套餐
              </div>
            </div>
          </nut-popup>
        </div>
      </div>
      <div class="form-item" v-if="showInternation && adminShow">
        <div class="form-control">
          <nut-button @click="showCountryDialog = true" small shape="circle">选择限制国家</nut-button>
          <div class="mobile-region-list-scroll" v-if="selectedCountriesName.length > 0">
            <div class="mobile-region-list">
              <span
                v-for="region in selectedCountriesName"
                :key="region"
                class="custom-tag"
                >{{ region }}</span
              > 
            </div>
          </div>
        </div>
      </div>

      <div class="form-item" v-if="!showInternation && adminShow">
        <div class="form-control">
          <nut-textinput
            v-model="selectProductPrice.operationPrice"
            placeholder="套餐价格"
            :clearBtn="false"
            :disabled="true"
          />
        </div>
      </div>

      <div class="form-item">
        <div class="form-control">
          <nut-cell
            :show-icon="true"
            title="套餐生效时间"
            :desc="selectedActivationTime"
            @click.native="showProductActivationTime = true"
          >
          </nut-cell>
          <nut-picker
            :is-visible="showProductActivationTime"
            :list-data="timeSet"
            :default-value-data="defaultProductActivationTime"
            @close="showProductActivationTime = false"
            @confirm="confirmProductActivationTime"
          ></nut-picker>
        </div>
      </div>
      <div class="form-item" v-if="propsParams.activationTime == '10'">
        <div class="form-control">
          <nut-cell
            :show-icon="true"
            title="自定义套餐生效时间"
            :desc="propsParams.activeDateTime"
            @click.native="showSwitchActivationTime = true"
          ></nut-cell>
          <nut-datepicker
            :is-visible="showSwitchActivationTime"
            title="请选择日期时间"
            type="datetime"
            startDate="2000-11-10 12:08"
            endDate="2999-12-31 23:59"
            :defaultValue="currentDateTime"
            @close="showSwitchActivationTime = false"
            @choose="chooseActivationTime"
          >
          </nut-datepicker>
        </div>
      </div>

      <div class="form-item" v-if="adminShow">
        <div class="form-control">
          <nut-cell :show-icon="false">
            <span slot="title">是否自动续套餐</span>
            <span slot="desc"><nut-switch :active.sync="propsParams.autoCharge" size="large" label="开|关"></nut-switch></span>
          </nut-cell>
        </div>
      </div>
      <!-- 自动充值套餐 -->
      <div class="form-item" v-if="adminShow && propsParams.autoCharge">
        <div class="form-control">
          <nut-cell :show-icon="true" title="自动充值套餐" @click.native="showAutoProduct = true">
            <span slot="desc" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block; max-width: 240px;">{{labelProductName(autoProduct)}}</span>
          </nut-cell>
          <nut-popup
            position="bottom"
            closeable
            close-icon="cross"
            v-model="showAutoProduct"
            :style="{ height: '50%' }"
            close-icon-position="top-right"
          >
            <div class="popup-header">
              <h3>选择套餐</h3>
              <div class="search-container">
                <nut-textinput
                  v-model="autoProductQuery"
                  placeholder="搜索套餐名称"
                  :clearBtn="true"
                  :disabled="false"
                  class="search-input"
                />
              </div>
            </div>
            <div class="popup-content">
              <div
                class="popup-item"
                v-for="item in filteredAutoPackages"
                :key="item.id"
                @click="selectAutoPackage(item)"
              >
                <div class="item-content">
                  <div class="item-name">{{ labelProductName(item) }}</div>
                  <div class="item-price">{{ item.price }}元/月</div>
                </div>
              </div>
              <div v-if="filteredPackages.length === 0" class="no-data">
                暂无匹配的套餐
              </div>
            </div>
          </nut-popup>
        </div>
      </div>

      <div class="form-item">
        <div class="form-control">
          <nut-cell :show-icon="false">
            <span slot="title">上传模式</span>
            <span slot="desc">
              <nut-radiogroup v-model="propsParams.fieldType" >
                <nut-radio label="1" @click.native="switchFieldType('1')">批量ICCIDS</nut-radio>
                <nut-radio label="2" @click.native="switchFieldType('2')">ICCID号段</nut-radio>
              </nut-radiogroup>
            </span>
          </nut-cell>
        </div>
      </div>

      <div class="form-item" v-if="propsParams.fieldType == '1'">
        <div class="form-control">
          <textarea
            class="custom-textarea"
            v-model="propsParams.iccids"
            rows="10"
            @input="handleCardSum"
            placeholder="请输入ICCID列表，每行一个"
          ></textarea>
        </div>
      </div>

      <div class="form-item" v-if="propsParams.fieldType == '2'">
        <div class="form-control">
          <nut-textinput
            v-model="propsParams.startIccid"
            placeholder="请输入开始ICCID"
            :clearBtn="true"
            :disabled="false"
          />
        </div>
        <div class="form-control">
          <nut-textinput
            v-model="propsParams.endIccid"
            placeholder="请输入结束ICCID号"
            :clearBtn="true"
            :disabled="false"
          />
        </div>
      </div>
      <div class="form-item" v-if="number > 0">
        <div class="form-control">
          <span class="selected-count"
            >{{ $t("app.packageRenewal.selectedCount")
            }}<em style="color:red">{{ number }}</em
            >{{ $t("app.packageRenewal.items") }}</span
          >
        </div>
      </div>

      <div class="form-item" v-if="!nextShow">
        <!-- <label class="form-label">充值信息</label> -->
        <div class="form-control">
          <div class="mobile-statistics">
            <nut-row :gutter="10">
              <nut-col :span="colSpan" v-if="userProductData.data.yd">
                <div class="mobile-statistic-item">
                  <div class="mobile-statistic-title">
                    {{ $t("app.packageRenewal.carrier.mobile") }}
                  </div>
                  <div class="mobile-statistic-value">
                    {{ userProductData.data.yd.totalCard }}/{{
                      userProductData.data.yd.totalMoney
                    }}{{ $t("app.common.currency") }}
                  </div>
                </div>
              </nut-col>
              <nut-col :span="colSpan" v-if="userProductData.data.dx">
                <div class="mobile-statistic-item">
                  <div class="mobile-statistic-title">
                    {{ $t("app.packageRenewal.carrier.telecom") }}
                  </div>
                  <div class="mobile-statistic-value">
                    {{ userProductData.data.dx.totalCard }}/{{
                      userProductData.data.dx.totalMoney
                    }}{{ $t("app.common.currency") }}
                  </div>
                </div>
              </nut-col>
              <nut-col :span="colSpan" v-if="userProductData.data.lt">
                <div class="mobile-statistic-item">
                  <div class="mobile-statistic-title">
                    {{ $t("app.packageRenewal.carrier.unicom") }}
                  </div>
                  <div class="mobile-statistic-value">
                    {{ userProductData.data.lt.totalCard }}/{{
                      userProductData.data.lt.totalMoney
                    }}{{ $t("app.common.currency") }}
                  </div>
                </div>
              </nut-col>
              <nut-col :span="colSpan" v-if="userProductData.data.gj">
                <div class="mobile-statistic-item">
                  <div class="mobile-statistic-title">
                    {{ $t("app.packageRenewal.carrier.international") }}
                  </div>
                  <div class="mobile-statistic-value">
                    {{ userProductData.data.gj.totalCard }}/{{
                      userProductData.data.gj.totalMoney
                    }}{{ $t("app.common.currency") }}
                  </div>
                </div>
              </nut-col>
            </nut-row>
            <div class="mobile-statistic-item mobile-statistic-total">
              <div class="total-content">
                <div class="mobile-statistic-title">
                  {{ $t("app.packageRenewal.total") }}
                </div>
                <div class="mobile-statistic-value">
                  {{ userProductData.totalCard }}/{{ userProductData.totalPrice
                  }}{{ $t("app.common.currency") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-item" v-if="!adminShow && !freeAgentShow">
        <div class="form-control">
          <nut-cell :show-icon="false">
              <span slot="title">账户余额</span>
              <span slot="desc" style="color: #f00;font-size: 18px;">{{availAmount}}元</span>
          </nut-cell>
        </div>
      </div>

      <div class="form-item" style="padding:0px 10px;" v-if="!adminShow && !freeAgentShow">
        <label class="form-label">支付方式</label>
        <div class="form-control">
          <nut-radiogroup v-model="propsParams.payType">
            <nut-radio :label="index" v-for="(item, index) in payList" :key="index">{{ item }}</nut-radio>
          </nut-radiogroup>
        </div>
      </div>

      <div class="form-item" v-if="propsParams.payType == '0'">
        <div class="form-control">
          <nut-textinput
            placeholder="请输入充值密码"
            v-model="propsParams.password"
            type="password"
          />
        </div>
      </div>

      <div class="form-item">
        <div class="form-control">
          <button class="custom-button primary" v-if="nextShow" @click="nextSubmit()">下一步</button>
          <button class="custom-button success" v-if="!nextShow" @click="handleSubmit()">立即付款</button>
        </div>
      </div>
    </div>

    <!-- 弹窗部分 -->
    <nut-popup v-model="dialogVisible" round position="bottom" :close-on-click-overlay="false" :closeable="true" :style="{ height: '40%' }" >
      <div class="payment-amount">
        <p style="color: #f00;">共计{{ resultObj.totalMoney }}元</p>
      </div>
      <div id="mobile-qrcodeDom"></div>
    </nut-popup>

    <!-- 国家选取弹窗 -->
    <nut-popup
      class="nut-popup"
      position="bottom"
      closeable
      close-icon="cross"
      v-model="showCountryDialog"
      :style="{ height: '70%' }"
      close-icon-position="top-right"
    >
      <div class="popup-header">
        <h3>选择国家</h3>
        <div class="search-container">
          <nut-textinput
            v-model="countrySearchQuery"
            placeholder="搜索国家名称"
            :clearBtn="true"
            :disabled="false"
            class="search-input"
          />
        </div>
      </div>
      <div class="popup-content">
        <nut-checkboxgroup
            ref="checkboxGroup"
            :checkBoxData="filteredCountryData"
            v-model="selectedCountries"
            @change="changeCountryData">
        </nut-checkboxgroup>
      </div>
      <div class="popup-footer">
        <div style="display: flex; justify-content: space-between; width: 100%;">
          <nut-button shape="circle"   @click="checkCountryAll(true)">全选</nut-button>
          <nut-button shape="circle"   @click="checkCountryAll(false)">取消全选</nut-button>
          <nut-button shape="circle"   @click="checkCountryAll()">反选</nut-button>
        </div>
      </div>
    </nut-popup>
  </div>
</template>

<script>
import { productList } from "@/api/api.js"; //不分页套餐列表
import { userInfo } from "@/api/api.js"; //获取个人中心的信息
import { selectGroupCountry} from "@/api/international.js"; 
import { userRechargeProductInfo , userSelectProductPrice } from "@/api/api.js"; //获取个人中心的信息
import { orderRechargePayment } from "@/api/api.js"; //计算价格
import { orderQueryRecharge } from "@/api/api.js"; //查看订单是否支付
import QRCode from "qrcodejs2";
// 按需导入 NutUI 组件

export default {
  name: "MobilePackageRenewal",
  components: {
  },
  data() {
    return {
      showCloseIcon: false,
      showCountryDialog: false,
      selectedCountries: [],
      selectedCountriesName: [],
      // 套餐搜索
      packageSearchQuery: "",
      currentProduct: {},
      showProductActivationTime: false,
      selectedActivationTime: "请选择卡套餐激活时间",
      defaultProductActivationTime: null,
      showSwitchActivationTime: false,

      showAutoProduct:false,
      autoProductQuery:"",
      autoProduct:{},

      countrySearchQuery:'',
      propsParams: {
        productId: undefined,
        operatorId: undefined,
        internationalSourceId: undefined,
        activationTime: 0,
        fieldType: "1",
        iccids: "",
        payType: 0,
        autoCharge: false,
        autoProductId: undefined,
        autoCount: "1",
        startIccid: "",
        endIccid: "",
      },
      levelCard: false,
      packagePrice: "",
      availAmount: "",
      totalPrice: 0,
      showInternation: false,
      operatorList: [],
      selectProductPrice: {},
      userProductData: {
        data: {
          dx: { totalCard: 0, totalMoney: 0 },
          yd: { totalCard: 0, totalMoney: 0 },
          lt: { totalCard: 0, totalMoney: 0 },
        },
      },
      nextShow: true,
      timeSet: [
        [
          {
            value: this.$t("app.packageRenewal.effectTime.immediate"),
            label: 1,
          },
          {
            value: this.$t("app.packageRenewal.effectTime.nextMonth"),
            label: 2,
          },
          {
            value: this.$t("app.packageRenewal.effectTime.expiry"),
            label: 5,
          },
        ],
      ],
      activationDay: 1,
      optPackage: [],
      number: 0,
      payList: [
        this.$t("app.packageRenewal.payment.balance"),
        this.$t("app.packageRenewal.payment.wechat"),
        this.$t("app.packageRenewal.payment.alipay"),
      ],
      // 弹窗部分
      dialogVisible: false,
      dialogTitle: this.$t("app.packageRenewal.confirmPayment"),
      resultObj: {},
      timer: null,
      productData: [],
      countryData: [],
    };
  },
  computed: {
    adminShow() {
      return this.$store.getters.user.userType == "1";
    },
    freeAgentShow() {
      return this.$store.getters.user.userId == "1392379806515073024";
    },
    cardIccids() {
      return this.$store.state.card.productIccids;
    },
    // 过滤后的套餐列表
    filteredPackages() {
      if (!this.packageSearchQuery) {
        return this.optPackage;
      }
      const query = this.packageSearchQuery.toLowerCase();
      return this.optPackage.filter((item) => {
        return (
          item.productName.toLowerCase().includes(query) ||
          this.labelProductName(item)
            .toLowerCase()
            .includes(query)
        );
      });
    },
    // 过滤后的自动充值套餐列表
    filteredAutoPackages() {
      if (!this.autoProductQuery) {
        return this.optPackage;
      }
      const query = this.autoProductQuery.toLowerCase();
      return this.optPackage.filter((item) => {
        return (
          item.productName.toLowerCase().includes(query) ||
          this.labelProductName(item)
            .toLowerCase()
            .includes(query)
        );
      });
    },
    // 国家过滤
    filteredCountryData(){
      if (!this.countrySearchQuery) {
        return this.countryData;
      }
      const query = this.countrySearchQuery.toLowerCase();
      return this.countryData.filter((item) => {
        return (
          item.label.toLowerCase().includes(query)
        );
      });
    },
    // 当前时间（用于日期选择器默认值）
    currentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 计算当前显示的运营商数量
    visibleCarrierCount() {
      let count = 0;
      if (this.userProductData.data.yd) count++;
      if (this.userProductData.data.dx) count++;
      if (this.userProductData.data.lt) count++;
      if (this.userProductData.data.gj) count++;
      return count;
    },
    // 根据运营商数量动态计算 col 的 span 值
    colSpan() {
      const count = this.visibleCarrierCount;
      if (count === 0) return 24;
      if (count === 1) return 24;
      if (count === 2) return 12;
      if (count === 3) return 8;
      if (count === 4) return 6;
      return 6; // 默认值
    },
  },
  methods: {
    // 资费套餐下拉
    queryServerList() {
      productList().then((res) => {
        this.optPackage = res.data.data;
      });
    },
    // 初始化信息
    initData() {
      let params = {
        userId: localStorage.getItem("userId"),
      };
      userInfo(params).then((res) => {
        this.availAmount = res.data.data.availAmount;
      });
    },
    selectPackage(item) {
      if (!item.id) {
        return;
      }
      this.currentProduct = item;
      this.autoProduct = item;
      this.countryData = [];
      this.showInternation = false;
      this.nextShow = true;
      if (item.type == "3") {
        this.showInternation = true;
        //国际
        this.initCountry();
      } else {
        //非国际套餐
        this.handleSelectProduct(item.id);
      }
      this.propsParams.productId = item.id;
      //默认和选中的套餐一样
      this.propsParams.autoProductId = item.id;
      // 关闭 popup
      // this.showCloseIcon = false;
    },
    selectActivationTime(item) {
      this.propsParams.activationTime = item.value;
    },
    selectAutoPackage(item) {
      this.propsParams.autoProductId = item.id;
      this.autoProduct = item
    },
    //国内展示价格
    handleSelectProduct(productId) {
      userSelectProductPrice({ productId }).then((res) => {
        this.selectProductPrice = res.data.data;
      });
    },
    initCountry(){
      let groupKey = "all"
      selectGroupCountry({groupKey}).then(res=>{
        // 构造数据为 label 和 value 结构
        this.countryData = res.data.data.map(item => ({
          id: item.id,
          label: item.name,
          value: item.countryCode
        }))
      })
    },
    labelProductName(item) {
      if(!item.productName){
        return "";
      }
      if (item.channel == "multi") {
        return item.id + "-【RX国际】" + item.productName;
      }
      if (item.channel == "cmlink") {
        return item.id + "-【ZY国际】" + item.productName;
      }
      if (item.channel == "cmBrazil") {
        return item.id + "-【BX国际】" + item.productName;
      }
      if (item.channel == "Quadcell") {
        return item.id + "-【QC国际】" + item.productName;
      }
      return item.id + "-" + item.productName;
    },

    handleCardSum() {
      this.nextShow = true;
      let iccids = this.propsParams.iccids ? this.propsParams.iccids.split("\n") : [];
      this.number = iccids.filter((item) => !!item).length;
      if (this.number == 0) {
        this.$store.dispatch("ClearProductIccids");
      } else {
        this.$store.dispatch(
          "CacheProductIccids",
          iccids.filter((item) => !!item).join(","),
        );
      }
    },
    switchFieldType(label) {
      this.nextShow = true;
      if (label == "2") {
        this.number = 0;
      }
      if (label == "1") {
        let iccids = this.propsParams.iccids ? this.propsParams.iccids.split("\n") : [];
        this.number = iccids.filter((item) => !!item).length;
      }
    },
    checkForm(){
      if (!this.propsParams.productId) {
        this.$toast.warn('请选择资费套餐');
        return false;
      }
      if(this.propsParams.autoCharge == true && !this.propsParams.autoProductId){
        this.$toast.warn('请选择自动续费套餐');
        return false;
      }
      
      let iccids = this.propsParams.iccids ? this.propsParams.iccids.split("\n") : [];
      if(this.propsParams.fieldType == '1' && iccids.length == 0){
        this.$toast.warn('请输入 ICCIDS');
        return false;
      }
      if(this.propsParams.fieldType == '2' && !this.propsParams.startIccid){
        this.$toast.warn('请输入开始ICCID');
        return false;
      }
      if(this.propsParams.fieldType == '2' && !this.propsParams.endIccid){
        this.$toast.warn('请输入结束ICCID');
        return false;
      }
      if(this.propsParams.payType == '0' && !this.propsParams.password){
        this.$toast.warn('请输入充值密码');
        return false;
      }
      return true;
    },
    nextSubmit() {
      // 简单的表单验证
      let check = this.checkForm();
      if(!check){
        return;
      }
      let { iccids } = this.propsParams;
      let params = {
        ...this.propsParams,
        iccids: iccids ? iccids.split("\n") : [],
        autoCharge : this.propsParams.autoCharge? '1':'0'
      };
      userRechargeProductInfo(params).then((res) => {
        this.nextShow = false;
        this.number = res.data.data.totalCard;
        if (this.number == 0) {
          this.nextShow = true;
          this.$toast.warn("输入的卡号都不存在，请重新输入！"); 
        }
        this.userProductData = res.data.data;
      });
    },
    handleSubmit() {
      // 简单的表单验证  
      let check = this.checkForm();
      if(!check){
        return;
      }
      let countryCodes = this.selectedCountries;
      let { iccids } = this.propsParams;
      let params = {
        ...this.propsParams,
        iccids: iccids ? iccids.split("\n") : [],
        countryCodes: countryCodes,
        autoCharge : this.propsParams.autoCharge? '1':'0'
      };
      //管理员支付或者免费用户支付  弹出确认按钮
      if (this.adminShow || this.freeAgentShow) {
        this.submitFreePay(params);
      } else {
        this.submitUserPay(params);
      }
    },
    submitFreePay(params) {
      let that = this
      this.$dialog({
        title: "温馨提示",
        content: "此次充值支付金额总计：0 元",
        closeBtn: true, //显式右上角关闭按钮
        onOkBtn(event) {
          //确定按钮点击事件
          orderRechargePayment(params).then((res) => {
            if (res.data.code == 200) {
              this.$toast.loading('已提交充值，请在订单页面查看内容',{ 
                  duration:2000
              });
              that.resetSubmitForm();
              setTimeout(() => {
                that.$router.push({ path: `/taskCenter/missionList` });
              }, 1000);
            } else {
              this.$toast.warn(res.data.message);
            }
          });
          this.close(); //关闭对话框
        },
        onCancelBtn(event) {
          //取消按钮点击事件，默认行为关闭对话框
          this.$toast.warn('取消充值');
          //return false;  //阻止默认“关闭对话框”的行为
        },
        onCloseBtn(event) {
          //右上角关闭按钮点击事件
          this.$toast.warn('取消充值');
          //return false;  //阻止默认“关闭对话框”的行为
        }
      });
    },
    submitUserPay(params) {
      if (params.payType == "0") {
        let money = this.userProductData.totalPrice;
        let that = this
        this.$dialog({
          title: "温馨提示",
          content: `此次套餐续费支付金额总计：${money} 元`,
          closeBtn: true, //显式右上角关闭按钮
          onOkBtn(event) {
            //确定按钮点击事件
            orderRechargePayment(params).then((res) => {
              if (res.data.code == 200) {
                this.$toast.loading('余额支付已完成，请在订单页面查看内容',{ 
                    duration:2000
                });
                that.resetSubmitForm();
                setTimeout(() => {
                  that.$router.push({ path: `/taskCenter/missionList` });
                }, 1000);
              } else if (res.data.code == 414) {
                this.$toast.warn("余额不足，请更换支付方式");
              } else {
                this.$toast.fail(res.data.message);
              }
            });
            this.close();
          },
          onCancelBtn(event) {
            this.$toast.warn('取消充值');
          },
          onCloseBtn(event) {
            this.$toast.warn('取消充值');
          }
        });
      } else {
        orderRechargePayment(params).then((res) => {
          if (res.data.code == 200) {
            this.resultObj = res.data.data;
            this.dialogVisible = true;
            this.$nextTick(() => {
              document.getElementById("mobile-qrcodeDom").innerHTML = ""; //先清空之前生成的二维码
              new QRCode("mobile-qrcodeDom", {
                width: 200,
                height: 200,
                text: res.data.data.result, //需要转换的链接
                render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                background: "#f0f", // 背景色
                foreground: "#ff0", // 前景色
              });
              this.isOrderPay();
            });
          } else if (res.data.code == 414) {
            this.$toast.warn("余额不足，请更换支付方式");
          } else {
            this.$toast.fail(res.data.message);
          }
        });
      }
    },
    resetSubmitForm() {
      this.initData();
      this.propsParams.iccids = "";
      this.propsParams.startIccid = "";
      this.propsParams.endIccid = "";
      this.$store.dispatch("ClearProductIccids");
      this.nextShow = true;
      this.number = 0;
      //清空页面数据
      this.userProductData = {
        data: {
          dx: { totalCard: 0, totalMoney: 0 },
          yd: { totalCard: 0, totalMoney: 0 },
          lt: { totalCard: 0, totalMoney: 0 },
        },
      };
      this.selectedCountries = [];
      this.selectedCountriesName =[];
      this.selectProductPrice = {};
      this.propsParams.autoCharge = false
      this.propsParams.autoProductId = undefined
      this.countrySearchQuery = ''
      this.autoProduct = {}
      this.autoProductQuery = ''
      this.currentProduct = {}
      this.packageSearchQuery = ''
      this.showInternation = false

      this.defaultProductActivationTime = [this.timeSet[0][0]];
      this.selectedActivationTime = this.timeSet[0][0].value;
      this.confirmProductActivationTime(this.timeSet[0]);


    },
    isOrderPay() {
      this.timer = setInterval(() => {
        orderQueryRecharge({ orderNum: this.resultObj.orderNum }).then(
          (res) => {
            if (res.data.data == "3") {
              this.$toast.loading('已提交充值，请在订单页面查看内容',{ 
                  duration:2000
              });
              this.$store.dispatch("tagsView/delView", this.$route);
              this.$store.dispatch("ClearProductIccids");
              clearInterval(this.timer);
              this.timer = null;
              this.$router.push({ path: `/taskCenter/missionList` });
            }
          },
        );
      }, 2000);
    },
    dialogClose() {
      clearInterval(this.timer);
      this.timer = null;
      this.dialogVisible = false;
    },
    closeDialog() {
      this.dialogClose();
    },
    handlePaste(event) {
      event.stopPropagation();
    },
    confirmProductActivationTime(item) {
      this.selectedActivationTime = item[0].value;
      if (item[0].label == 0) {
        this.propsParams.activationTime = "";
      } else {
        this.propsParams.activationTime = item[0].label - 1;
      }
      if (item[0].label == 11) {
        this.showSwitchActivationTime = true;
      }
    },
    chooseActivationTime(time) {
      this.propsParams.activeDateTime = time[5];
    },
    // 国家选择变化时更新 selectedCountriesName
    changeCountryData() {
      // 根据选中的 countryCode 找到对应的国家名称
      this.selectedCountriesName = this.filteredCountryData
        .filter(item => this.selectedCountries.includes(item.value))
        .map(item => item.label);
    },
    // 国家选择的全选、取消全选、反选功能
    checkCountryAll(flag) {
      if (flag === true) {
        // 全选：将所有过滤后的国家的 value 加入 selectedCountries
        this.selectedCountries = this.filteredCountryData.map(item => item.value);
        // 全选：将所有过滤后的国家的 name 加入 selectedCountriesName
        this.selectedCountriesName = this.filteredCountryData.map(item => item.label);
      } else if (flag === false) {
        // 取消全选：清空 selectedCountries
        this.selectedCountries = [];
        // 取消全选：清空 selectedCountriesName
        this.selectedCountriesName = [];
      } else {
        // 反选：切换每个国家的选中状态
        // const allValues = this.filteredCountryData.map(item => item.value);
        const currentValues = new Set(this.selectedCountries);
        const newValues = [];
        const newNames = [];
        this.filteredCountryData.forEach(item => {
          if (currentValues.has(item.value)) {
            // 如果当前已选中，则移除
          } else {
            // 如果当前未选中，则添加
            newValues.push(item.value);
            newNames.push(item.label);
          }
        });
        this.selectedCountries = newValues;
        this.selectedCountriesName = newNames;
      }
    },
  },
  watch: {
    $route: {
      handler: function(to, from) {
        if (to.name == "packageRenewal" || to.name == "batchRecharge") {
          this.queryServerList();
          if (!!this.cardIccids) {
            this.propsParams.iccids = this.cardIccids.replace(/,/g, "\n");
            this.number = this.propsParams.iccids.split("\n").length;
          }
        }
      },
      deep: true,
    },
  },
  created() {
    this.queryServerList();
    this.initData();
    if (!!this.cardIccids) {
      this.propsParams.iccids = this.cardIccids.replace(/,/g, "\n");
      this.number = this.propsParams.iccids.split("\n").length;
    }
    if (this.adminShow) {
      this.timeSet = [
        [
          {
            value: "默认",
            label: 0,
          },
          {
            value: this.$t("app.packageRenewal.effectTime.immediate"),
            label: 1,
          },
          {
            value: this.$t("app.packageRenewal.effectTime.oneMonth"),
            label: 2,
          },
          {
            value: this.$t("app.packageRenewal.effectTime.threeMonths"),
            label: 3,
          },
          {
            value: this.$t("app.packageRenewal.effectTime.sixMonths"),
            label: 4,
          },
          {
            value: this.$t("app.packageRenewal.effectTime.expiry"),
            label: 5,
          },
          {
            value: this.$t("app.packageRenewal.effectTime.customTime"),
            label: 11,
          },
        ],
      ];
      this.levelCard = true;
    }
    this.defaultProductActivationTime = [this.timeSet[0][0]];
    this.selectedActivationTime = this.timeSet[0][0].value;
    this.confirmProductActivationTime(this.timeSet[0]);
  },
  mounted() {
  },
};
</script>
<!-- 单独引入样式  防止污染elementUI 样式 -->
<style scoped lang="less">
@import '~@nutui/nutui/dist/packages/cell/cell.css';
@import '~@nutui/nutui/dist/packages/col/col.css';
@import '~@nutui/nutui/dist/packages/checkboxgroup/checkboxgroup.css';
@import '~@nutui/nutui/dist/packages/popup/popup.css';
@import '~@nutui/nutui/dist/packages/dialog/dialog.css';
@import '~@nutui/nutui/dist/packages/textinput/textinput.css';
@import '~@nutui/nutui/dist/packages/button/button.css';
@import '~@nutui/nutui/dist/packages/picker/picker.css';
@import '~@nutui/nutui/dist/packages/datepicker/datepicker.css';
@import '~@nutui/nutui/dist/packages/radiogroup/radiogroup.css';
@import '~@nutui/nutui/dist/packages/toast/toast.css';
/* 整体布局 */
.mobile-content {
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
  position: relative;
  z-index: 1;
}

/* 表单容器 */
.mobile-form {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  z-index: 2;
}

/* Flex行布局 */
.flex-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* 表单项样式 */
.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  clear: both;
  margin-bottom: 16px;
}

/* 为 nut-cell 移除默认的上下边框，避免重复 */
.form-item .form-control ::v-deep.nut-cell {
  --nut-cell-border-bottom: none;
  --nut-cell-border-top: none;
  border-left: 1px solid #dcdfe6;
  border-right: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

/* 标签样式 */
.form-label {
  font-size: 14px;
  color: #303133;
  line-height: 1.5;
  font-weight: 500;
  width: 100%;
  max-width: 100%;
  text-align: left;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-wrap: break-word;
}

/* Popup 样式 */
.popup-header {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
  h3 {
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .search-container {
    margin-top: 12px;
    width: 100%;
  }
  .search-input {
    width: 100%;
    --nut-textinput-height: 36px;
    --nut-textinput-border-radius: 18px;
    --nut-textinput-font-size: 14px;
    --nut-textinput-background-color: #f5f7fa;
    --nut-textinput-placeholder-color: #999;
    --nut-textinput-border-color: #dcdfe6;
    --nut-textinput-focus-border-color: #409eff;
  }
}
.popup-content {
  padding: 16px;
  height: calc(100% - 120px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.popup-item {
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background-color: #e9ecef;
    transform: translateY(-2px);
  }
  &:active {
    transform: translateY(0);
  }
  .item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-name {
    font-size: 14px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    margin-right: 12px;
  }
  .item-price {
    font-size: 14px;
    font-weight: 600;
    color: #f00;
    white-space: nowrap;
  }
}
.no-data {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}

/* 内容区域样式 */
.form-control {
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
  position: relative;
}

/* 输入框样式 */
.custom-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }

  &:disabled {
    background-color: #f5f7fa;
    color: #909399;
    cursor: not-allowed;
  }
}

/* 文本域样式 */
.custom-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  resize: vertical;
  min-height: 100px;

  &:focus {
    outline: none;
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}

/* 选择器样式 */
.custom-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  position: relative;
  z-index: 3;

  &:hover {
    border-color: #c0c4cc;
  }

  &:focus-within {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}

.select-value {
  flex: 1;
  text-align: left;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-arrow {
  color: #909399;
  font-size: 12px;
  transition: transform 0.3s ease;
}

.select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  margin-top: -1px;

  .select-option {
    padding: 10px 12px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #ecf5ff;
    }
  }
}

/* 按钮样式 */
.custom-button {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  background-color: #ffffff;
  cursor: pointer;

  &:hover {
    border-color: #c0c4cc;
    color: #606266;
  }

  &.primary {
    background-color: #409eff;
    border-color: #409eff;
    color: #ffffff;

    &:hover {
      background-color: #66b1ff;
      border-color: #66b1ff;
    }
  }

  &.success {
    background-color: #67c23a;
    border-color: #67c23a;
    color: #ffffff;

    &:hover {
      background-color: #85ce61;
      border-color: #85ce61;
    }
  }
}

/* 开关样式 */
.custom-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin-top: 4px;

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .switch-slider {
      background-color: #13ce66;

      &:before {
        transform: translateX(20px);
      }
    }

    &:focus + .switch-slider {
      box-shadow: 0 0 1px #13ce66;
    }
  }

  .switch-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #c0ccda;
    transition: 0.4s;
    border-radius: 20px;

    &:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 2px;
      bottom: 2px;
      background-color: white;
      transition: 0.4s;
      border-radius: 50%;
    }
  }
}

/* 单选按钮组样式 */
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .radio-option {
    display: flex;
    align-items: center;
    cursor: pointer;

    input[type="radio"] {
      margin-right: 8px;
    }

    .radio-label {
      font-size: 14px;
      color: #303133;
    }
  }
}

/* 标签样式 */
.custom-tag {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 12px;
  background-color: #ecf5ff;
  color: #409eff;
  margin: 0 5px 5px 0;

  &.success {
    background-color: #f0f9eb;
    color: #67c23a;
  }
}

/* 区域列表滚动容器 */
.mobile-region-list-scroll {
  max-height: 150px;
  overflow-y: auto;
  margin-top: 10px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 12px;
  background-color: #fafafa;
}

/* 区域标签列表 */
.mobile-region-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 5px 0;
}

/* 统计信息容器 */
.mobile-statistics {
  margin-top: 20px;
  background-color: #ffffff;
  padding: 18px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 统计信息项 */
.mobile-statistic-item {
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 8px;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    background-color: #f0f9ff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

/* 统计信息标题 */
.mobile-statistic-title {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  text-align: center;
}

/* 统计信息值 */
.mobile-statistic-value {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  text-align: center;
}

/* 总计统计项 */
.mobile-statistic-total {
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
  padding: 15px;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #e6f7ff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .total-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .mobile-statistic-title {
    font-weight: 600;
    color: #1890ff;
    text-align: left;
    margin-bottom: 0;
  }

  .mobile-statistic-value {
    font-size: 16px;
    font-weight: 600;
    color: #1890ff;
    text-align: right;
  }
}

/* 二维码容器 */
#mobile-qrcodeDom {
  width: 220px;
  height: 220px;
  margin: 25px auto;
  padding: 15px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
}

/* 标签容器 */
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 12px;
}


/* 国家选择弹窗样式 */
.nut-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.nut-popup .popup-header {
  padding: 16px;
  border-bottom: 1px solid #eee;
  background-color: #fff;
}

.nut-popup .popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.nut-popup .popup-footer {
  padding: 16px;
  border-top: 1px solid #eee;
  background-color: #fff;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.nut-popup .search-container {
  margin-top: 12px;
}

.nut-popup .search-input {
  --nut-textinput-height: 36px;
  --nut-textinput-border-radius: 18px;
  --nut-textinput-background-color: #f5f5f5;
}

.nut-popup .nut-buttongroup {
  justify-content: space-between;
  width: 100%;
}

.nut-popup .nut-checkboxgroup {
  margin-bottom: 16px;
}

.nut-popup .nut-checkbox {
  margin-right: 8px;
}

.nut-popup .nut-checkbox-label {
  margin-right: 16px;
}

.payment-amount {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 0px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #f0f0f0;
  width: 100%;
  p {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    text-align: center;
  }
}

/* 滚动条样式 */
.mobile-region-list-scroll::-webkit-scrollbar {
  width: 6px;
}

.mobile-region-list-scroll::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  border-radius: 3px;
}

.mobile-region-list-scroll::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.mobile-region-list-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

/* Firefox 滚动条样式 */
.mobile-region-list-scroll {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 选中数量提示 */
.selected-count {
  font-size: 14px;
  color: #666;
  display: block;
  margin-top: 5px;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  /* 中等屏幕整体调整 */
  .mobile-content {
    padding: 12px;
    min-height: calc(100vh - 70px);
  }

  /* 表单容器 */
  .mobile-form {
    padding: 18px;
    border-radius: 10px;
    gap: 14px;
  }

  /* 标签 */
  .form-label {
    font-size: 14px;
  }

  /* 输入控件 */
  .custom-input,
  .custom-textarea,
  .custom-select {
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  /* 小屏幕整体调整 */
  .mobile-content {
    padding: 10px;
    min-height: calc(100vh - 60px);
  }

  /* 表单容器 */
  .mobile-form {
    padding: 15px;
    border-radius: 8px;
    gap: 12px;
  }

  /* 标签 */
  .form-label {
    font-size: 13px;
  }

  /* 输入控件 */
  .custom-input,
  .custom-textarea,
  .custom-select {
    font-size: 13px;
  }

  /* 统计信息 */
  .mobile-statistics {
    padding: 15px;
    border-radius: 8px;
  }

  /* 统计项 */
  .mobile-statistic-item {
    padding: 12px;
    margin-bottom: 6px;
    border-radius: 6px;
  }

  /* 支付方式 */
  .mobile-pay-item {
    min-width: calc(50% - 6px);
    padding: 12px 8px;
    font-size: 12px;
  }

  /* 选中支付方式的三角形 */
  .mobile-pay-item.cur::after {
    border-width: 0 14px 14px 0;
  }

  /* 二维码容器 */
  #mobile-qrcodeDom {
    padding: 12px;
    margin: 20px auto;
  }

  /* 按钮 */
  .custom-button {
    font-size: 14px;
    padding: 10px 0;
  }

  /* 单选按钮 */
  .radio-option {
    font-size: 13px;
  }
}

@media screen and (max-width: 360px) {
  /* 极小屏幕调整 */
  .mobile-content {
    padding: 8px;
  }

  /* 表单容器 */
  .mobile-form {
    padding: 12px;
  }

  /* 标签 */
  .form-label {
    font-size: 12px;
  }

  /* 输入控件 */
  .custom-input,
  .custom-textarea,
  .custom-select {
    font-size: 12px;
  }

  /* 统计项 */
  .mobile-statistic-item {
    padding: 10px;
  }

  /* 统计值 */
  .mobile-statistic-value {
    font-size: 14px;
  }
}

/* 动画效果 */
.custom-select,
.custom-input,
.custom-textarea,
.custom-button,
.mobile-statistic-item,
.mobile-pay-item {
  transition: all 0.3s ease;
}

/* 错误提示样式 */
.form-item.error .custom-input,
.form-item.error .custom-textarea {
  border-color: #f56c6c;
}

/* 成功提示样式 */
.form-item.success .custom-input,
.form-item.success .custom-textarea {
  border-color: #67c23a;
}
</style>
